/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopPhaseContentRow', 'model/WorkshopPhaseContentRowReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopPhaseContentRow'), require('../model/WorkshopPhaseContentRowReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopPhaseContentRowApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopPhaseContentRow, root.ForStractionServiceApi.WorkshopPhaseContentRowReport);
  }
}(this, function(ApiClient, WorkshopPhaseContentRow, WorkshopPhaseContentRowReport) {
  'use strict';

  /**
   * WorkshopPhaseContentRow service.
   * @module api/WorkshopPhaseContentRowApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopPhaseContentRowApi. 
   * @alias module:api/WorkshopPhaseContentRowApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopPhaseContentRowAddPut operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopPhaseContentRow} body 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopPhaseContentRowAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseContentRowAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseContentRowDeleteGet operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopPhaseContentRowDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopPhaseContentRowDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseContentRowEditPut operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopPhaseContentRow} body 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopPhaseContentRowEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseContentRowEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseContentRowLoadAllGet operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopPhaseContentRowReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopPhaseContentRowReport>}
     */
    this.workshopPhaseContentRowLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopPhaseContentRowReport];

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseContentRowLoadGet operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopPhaseContentRowReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopPhaseContentRowReport}
     */
    this.workshopPhaseContentRowLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopPhaseContentRowLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopPhaseContentRowReport;

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPhaseContentRowLoadWorkshopContentPut operation.
     * @callback module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadWorkshopContentPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopPhaseContentRowReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadWorkshopContent
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkshopPhaseContentRowApi~workshopPhaseContentRowLoadWorkshopContentPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopPhaseContentRowReport>}
     */
    this.workshopPhaseContentRowLoadWorkshopContentPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPhaseContentRowLoadWorkshopContentPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopPhaseContentRowLoadWorkshopContentPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopPhaseContentRowReport];

      return this.apiClient.callApi(
        '/WorkshopPhaseContentRow/loadWorkshopContent', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
